/* Page produit — Le Temple du Foot (31/10/2026, v3) : barre sticky mobile, avis qui défilent, tri + « Voir plus » de la section avis, vidéos cassées masquées. */
(function(){
  if(window.__ltdfPdp)return;window.__ltdfPdp=true;
  var bar=null,t=null;

  /* ---- barre sticky (mobile) ---- */
  function build(){
    if(bar)return bar;
    bar=document.createElement('div');bar.className='pp-sticky';
    bar.innerHTML='<div class="pp-sticky-p"><b></b><span></span></div><button type="button" class="pp-sticky-btn">Ajouter au panier</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click',function(){
      var vp=document.querySelector('variant-picker')||document.querySelector('add-to-cart-component');
      if(vp){var y=vp.getBoundingClientRect().top+window.pageYOffset-130;window.scrollTo({top:y,behavior:'smooth'});}
    });
    return bar;
  }
  function sticky(){
    var btn=document.querySelector('add-to-cart-component button[name="add"]');var b=build();
    if(!btn){b.classList.remove('is-on');return;}
    var p=document.querySelector('.pp-price-now'),h=document.querySelector('.pp-title');
    b.querySelector('b').textContent=p?p.textContent.trim():'';
    b.querySelector('span').textContent=h?h.textContent.trim():'Choisis ta taille';
    b.classList.toggle('is-on',btn.getBoundingClientRect().bottom<0);
  }

  /* ---- avis qui défilent (sous le bouton) ---- */
  function carou(){
    document.querySelectorAll('[data-pp-carou]:not([data-ready])').forEach(function(c){
      c.setAttribute('data-ready','1');
      var track=c.querySelector('[data-track]'),n=track.children.length,i=0,timer=null;
      function go(k){i=(k+n)%n;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});}
      function auto(){clearInterval(timer);timer=setInterval(function(){if(!document.hidden)go(i+1);},4500);}
      c.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){go(i+parseInt(b.getAttribute('data-dir'),10));auto();});});
      track.addEventListener('scroll',function(){var k=Math.round(track.scrollLeft/track.clientWidth);if(k!==i){i=k;}},{passive:true});
      track.addEventListener('touchstart',function(){clearInterval(timer);},{passive:true});
      track.addEventListener('touchend',auto,{passive:true});
      auto();
    });
  }

  /* ---- section avis : tri + Voir plus ---- */
  function avis(){
    var s=document.querySelector('[data-pp-avis]:not([data-ready])');if(!s)return;s.setAttribute('data-ready','1');
    var menu=s.querySelector('[data-sort-menu]'),grid=s.querySelector('[data-grid]'),more=s.querySelector('[data-more]');
    s.querySelectorAll('[data-sort-btn]').forEach(function(b){b.addEventListener('click',function(e){e.stopPropagation();menu.hidden=!menu.hidden;});});
    document.addEventListener('click',function(){menu.hidden=true;});
    menu.querySelectorAll('[data-sort]').forEach(function(b){b.addEventListener('click',function(e){e.stopPropagation();
      var dir=b.getAttribute('data-sort')==='old'?1:-1;
      var cards=Array.prototype.slice.call(grid.children);
      cards.sort(function(a,c){return (a.getAttribute('data-d')>c.getAttribute('data-d')?1:-1)*dir;});
      cards.forEach(function(k){grid.appendChild(k);});
      menu.querySelectorAll('button').forEach(function(x){x.classList.toggle('is-on',x===b);});menu.hidden=true;});});
    if(more){
      var total=grid.children.length,shown=window.innerWidth<1000?4:8;
      if(total<=shown){more.hidden=true;}
      var lblMore=more.getAttribute('data-more')||'Voir plus d’avis',lblLess=more.getAttribute('data-less')||'Voir moins';
      more.textContent=lblMore+' ('+(total-shown)+')';
      more.addEventListener('click',function(){var open=grid.classList.toggle('is-open');more.textContent=open?lblLess:(lblMore+' ('+(total-shown)+')');if(!open){s.scrollIntoView({behavior:'smooth',block:'start'});}});
    }
  }

  /* ---- vidéos qui ne chargent pas : on masque la carte ---- */
  function videos(){
    document.querySelectorAll('.section-vsr video:not([data-chk])').forEach(function(v){v.setAttribute('data-chk','1');
      v.addEventListener('error',function(){var s=v.closest('.vsr-slide');if(s)s.classList.add('is-broken');});
      if(v.error){var s=v.closest('.vsr-slide');if(s)s.classList.add('is-broken');}
    });
  }

  function all(){sticky();carou();avis();videos();}
  function boot(){all();window.addEventListener('scroll',sticky,{passive:true});window.addEventListener('resize',sticky);new MutationObserver(function(){clearTimeout(t);t=setTimeout(all,80);}).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
